import React from 'react';
import { Options as HighChartOptions } from 'highcharts/highcharts';

import ChartV2 from '../ChartV2';
import HighchartStyles from '../HighchartStyles';
import IncompatibleComparison from '../IncompatibleComparison';
import NoDataToDisplay from '../V5Gadget/NoDataToDisplay';
import GroupVsRemainderTooltip from './GroupVsRemainderTooltip';

const GroupVsRemainderView = ({
  options,
  hasResults,
  compatibleComparison,
}: {
  options: HighChartOptions | undefined;
  hasResults: boolean;
  compatibleComparison: boolean;
}) => {
  if (!options) return null;

  if (!compatibleComparison) {
    return <IncompatibleComparison />;
  } else if (compatibleComparison && !hasResults) {
    return <NoDataToDisplay size={'normal'} />;
  }

  return (
    <HighchartStyles
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <ChartV2
        TooltipComponent={GroupVsRemainderTooltip}
        options={options}
        positionMode={'multi-shared-points'}
      />
    </HighchartStyles>
  );
};

export default GroupVsRemainderView;
